export function expandKlingV3Runs({ runCount = 1 } = {}) { return Array.from({ length: Math.max(1, runCount) }, () => ({})) }
